import { useEffect } from 'react';
import { useToast } from './ToastProvider';
import { setToastContext } from '../utils/toast';

const ToastInitializer = ({ children }) => {
  const { showToast } = useToast();

  useEffect(() => {
    setToastContext({ showToast });
  }, [showToast]);

  return children;
};

export default ToastInitializer;
